__turbopack_context__.v({
  "commandPaletteContainer": "search-bar-combobox-module-scss-module__YsrTOa__commandPaletteContainer",
  "filterChip": "search-bar-combobox-module-scss-module__YsrTOa__filterChip",
  "helperText": "search-bar-combobox-module-scss-module__YsrTOa__helperText",
  "iconContainer": "search-bar-combobox-module-scss-module__YsrTOa__iconContainer",
  "input": "search-bar-combobox-module-scss-module__YsrTOa__input",
  "noResults": "search-bar-combobox-module-scss-module__YsrTOa__noResults",
  "rule": "search-bar-combobox-module-scss-module__YsrTOa__rule",
  "searching": "search-bar-combobox-module-scss-module__YsrTOa__searching",
  "submitButton": "search-bar-combobox-module-scss-module__YsrTOa__submitButton",
  "suggestion": "search-bar-combobox-module-scss-module__YsrTOa__suggestion",
  "suggestionCategoryLabel": "search-bar-combobox-module-scss-module__YsrTOa__suggestionCategoryLabel",
  "suggestionContainer": "search-bar-combobox-module-scss-module__YsrTOa__suggestionContainer",
  "wrapper": "search-bar-combobox-module-scss-module__YsrTOa__wrapper",
});
